// src/utils/constants.js
export const COURSE_CATEGORIES = {
  'programming-tech': { label: 'Programming & Tech', dbTags: ['programming', 'tech'] },
  'tech': { label: 'Tech', dbTags: ['tech'] },
  'data-science': { label: 'Data Science', dbTags: ['data-science'] },
  
  // Notice these keys match your Navbar Hrefs exactly now:
  'management-company': { label: 'Management', dbTags: ['management', 'leadership'] },
  'management': { label: 'Management', dbTags: ['management', 'leadership'] },
  'startup-company': { label: 'Startup & Business', dbTags: ['startup', 'business', 'finance'] },
  'finance-business': { label: 'Finance & Business', dbTags: ['finance', 'business', 'money'] },
  'startup': { label: 'Startup & Business', dbTags: ['startup', 'business', 'finance'] },
  'arts-humanities': { label: 'Arts & Humanities', dbTags: ['arts', 'humanities'] }
};